import React from 'react'
import { Box, Typography } from '@mui/material'
import { Field, ErrorMessage } from 'formik'
import AdxDropzoneImagePdf from 'components/reusable/AdxDropzoneImagePdf'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

const FillForm = ({ item, values, setFieldValue, errors }) => {
  return (
    <>
      {/* Explanation */}
      <Box>
        <Typography variant="body1" color="dark-gray-text.main">
          Upload relevant documents as proof of you working on selected dates.
        </Typography>
      </Box>
      {/* Attachmentment */}
      <Box>
        <Typography sx={{ mb: 2 }} variant="body2" color="dark-gray-text.main">
          Attachment
        </Typography>
        <Field name="file" values={values.file} type="hidden" />
        <AdxDropzoneImagePdf
          file={
            Object.keys(values.file).length !== 0
              ? { name: values?.file?.name, url: values?.file?.awsUrl }
              : null
          }
          label={`Attachment`}
          title="Drag an attachment from computer"
          subtitle="or click here to upload"
          folder="leave_attachment"
          setFieldValue={setFieldValue}
          errorMessage={<ErrorMessage name="file" component={AdxErrorMessage} />}
          isErrorShown={errors.file}
        />
      </Box>
      {/* Credit request summary */}
      <Box
        sx={{
          backgroundColor: 'gray-background.main',
          rowGap: 1.5,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography
          variant="body1"
          color="light-gray-text.main"
          sx={{ textDecoration: 'underline' }}
        >
          Leave Credit Summary:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: null, sm: 'center' },
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="body1" color="light-gray-text.main">
            Date
          </Typography>
          <Typography variant="body1" color="dark-gray-text.main">
            {item?.start_date} - {item?.end_date}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: null, sm: 'center' },
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="body1" color="light-gray-text.main">
            Days to be requested
          </Typography>
          <Typography variant="body1" color="dark-gray-text.main">
            {item?.duration}
          </Typography>
        </Box>
        <Box
          sx={{
            width: 1,
          }}
        >
          <Typography variant="body1" color="light-gray-text.main">
            Reason
          </Typography>
          <Typography variant="body1" color="dark-gray-text.main">
            {item?.reason}
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default FillForm
